import {useEffect, useRef, useState} from "react";
import {businessPages} from "../actions/ApiCalls";
import Header from "../Components/Header/Header";
import HeaderWhite from "../Components/Header/HeaderWhite";
import Footer from "../Components/Footer/Footer";
import {BASE_URL, IMAGE_URL} from "../path";

function Sustainability() {
    const [data, setData] = useState<any[]>([]);
    const [isMobile, setIsMobile] = useState<boolean>(false);
    const publicUrl = IMAGE_URL;
    const firstTextRef = useRef<HTMLDivElement | null>(null);
    const [currentHash, setCurrentHash] = useState('#partnership');
    const [isAtTop, setIsAtTop] = useState(true);

    const linkStyle: React.CSSProperties = {
        color: 'white',
        fontSize: '10px',
        fontFamily: "'Vinimark-Diatype', sans-serif",
        fontWeight: 600,
        textTransform: 'uppercase',
        textDecoration: 'underline',
        cursor: 'pointer',
        lineHeight: '13px'
    };

    const scrollToTextSection = () => {
        if (firstTextRef.current) {
            firstTextRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };

    let foundFirstTextSection = false;
    let foundFirstImageSection = false;

    useEffect(() => {
        const handleScroll = () => setIsAtTop(window.scrollY === 0);
        window.addEventListener("scroll", handleScroll);
        handleScroll();
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const id = entry.target.getAttribute("id");
                        if (id) {
                            setCurrentHash(`#${id}`);
                        }
                    }
                });
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: 0.6,
            }
        );



        const sections = document.querySelectorAll(".our-story-text-section-wrapper[id]");
        sections.forEach((section) => observer.observe(section));

        return () => {
            sections.forEach((section) => observer.unobserve(section));
        };
    }, [data]);

    useEffect(() => {
        document.title = "Vinimark | Our Approach";

        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        businessPages(4)
            .then(response => {
                setData(response.data);
            })
            .catch(error => {
                console.error("Failed to fetch business pages:", error);
            });

        return () => window.removeEventListener("resize", handleResize);
    }, []);


    return (
        <div style={{marginBottom: '0'}}>
            {isMobile ? <Header /> : (isAtTop ? <HeaderWhite /> : <Header />)}

            <div className="our-story-container" style={{ marginTop: '-50px'}}>
                {data.map((page, index) => {
                    const imageUrl = `${publicUrl}/${isMobile ? page.mobile_image : page.image}`;

                    const isTextSection = !page.image;
                    const assignRef = isTextSection && !foundFirstTextSection;
                    if (assignRef) foundFirstTextSection = true;

                    const isFirstImageWithTitle = page.image && page.title && !foundFirstImageSection;
                    if (isFirstImageWithTitle) foundFirstImageSection = true;

                    const isMobimarketSection = page.title === 'MOBIMARKET & DIGITAL INNOVATION';
                    const isSustainabilitySection = page.title === 'SUSTAINABILITY SUPPORT';

                    return (
                        <div key={index}>
                            {page.image ? (
                                page.title ? (
                                    <>
                                        <div
                                            className={`our-story-image-background ${page.is_full ? "full" : "centered"}`}
                                            style={{
                                                backgroundImage: `url(${imageUrl})`,
                                                backgroundSize: 'cover',
                                                backgroundPosition: 'center',
                                                width: '100vw',
                                                display: 'flex',
                                                flexDirection: isMobile ? 'column' : 'row',
                                                position: 'relative',
                                                marginTop: isMobile ? '125px' : '20px',
                                                minHeight: isFirstImageWithTitle ? '100vh' : '400px',
                                                paddingBottom: '72px'
                                            }}
                                        >
                                            {/* Optional layout spacer */}
                                            <div style={{ flex: 1 }}></div>

                                            {/* Content section anchored to bottom-left */}
                                            <div
                                                style={{
                                                    flex: 1,
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'flex-end', // push to bottom
                                                    alignItems: 'flex-start',   // align to left
                                                    marginLeft: window.innerWidth < 575 ? '24px' : '46px',
                                                    color: '#fff',
                                                    textAlign: 'left',
                                                    minHeight: '100vh',

                                                }}
                                            >
                                                <div>
                                                    <p style={{
                                                        fontWeight: 300,
                                                        fontSize: '32px',
                                                        marginBottom: '10px',
                                                        lineHeight: '32px'
                                                    }}>
                                                        {page.title}
                                                    </p>
                                                    <a onClick={scrollToTextSection} style={linkStyle}>
                                                        Read more
                                                    </a>
                                                </div>
                                            </div>
                                        </div>





                                        <div style={{ marginBottom: isMobile ? '-25px' : 0, padding: isMobile ? '24px 24px 0 24px' : 0 }}>

                                        </div>
                                    </>
                                ) : (
                                    <img
                                        src={imageUrl}
                                        alt="Business Page"
                                        className={page.is_full ? "our-story-image-full" : "our-story-image-centered"}
                                    />

                                ) ): (
                                <div
                                    className="our-story-text-section-wrapper"
                                    ref={assignRef ? firstTextRef : null}
                                    id={page.title ? page.title.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '') : undefined}
                                >
                                    <div className={`our-story-text-section ${isMobile ? "mobile" : ""}`}>
                                        <div className="navigation-container">

                                        </div>
                                        <div className="our-story-text-block" >
                                            <div style={{width: window.innerWidth <= 575 ? '100%' : '70%', marginLeft: window.innerWidth < 575 ? '0px' : '46px'}}>
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: ((): any => {
                                                            const rightText = page.right_text || '';
                                                            const styledRightText = rightText.replace(/<p>/g, '<p style="font-weight: 400">');
                                                            return `${page.title ? `<h2 style="font-weight: 600" class="our-story-title">${page.title}</h2>` : ''}${styledRightText}`;
                                                        })()
                                                    }}
                                                />
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>

            <Footer />
        </div>
    );
    return <div>

    </div>
}

export default Sustainability;
